import React from 'react';
import { Archive, Trash2, Mail } from 'lucide-react';

interface EmailBulkActionsProps {
  selectedCount: number;
  onAction: (action: 'archive' | 'delete' | 'mark_read') => void;
}

export default function EmailBulkActions({
  selectedCount,
  onAction
}: EmailBulkActionsProps) {
  return (
    <div className="fixed bottom-4 left-1/2 transform -translate-x-1/2 bg-white rounded-lg shadow-lg border border-gray-200 px-4 py-2 flex items-center space-x-4">
      <span className="text-sm text-gray-600">
        {selectedCount} emails selected
      </span>
      
      <div className="flex items-center space-x-2">
        <button
          onClick={() => onAction('mark_read')}
          className="p-2 text-gray-600 hover:bg-gray-100 rounded-lg"
        >
          <Mail className="w-4 h-4" />
        </button>
        
        <button
          onClick={() => onAction('archive')}
          className="p-2 text-gray-600 hover:bg-gray-100 rounded-lg"
        >
          <Archive className="w-4 h-4" />
        </button>
        
        <button
          onClick={() => onAction('delete')}
          className="p-2 text-red-600 hover:bg-red-50 rounded-lg"
        >
          <Trash2 className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
}